import type { OutreachEnrollment } from '@/lib/outreach';

/** What a campaign's sequences came to, counted on replies, never on opens. */
export const campaignCounts = (enrollments: OutreachEnrollment[]) => ({
  contacted: enrollments.filter((enrollment) => enrollment.messages.some((message) => message.status === 'sent')).length,
  active: enrollments.filter((enrollment) => enrollment.status === 'active').length,
  replied: enrollments.filter((enrollment) => enrollment.status === 'replied').length,
  optedOut: enrollments.filter((enrollment) => enrollment.status === 'opted_out').length,
  bounced: enrollments.filter((enrollment) => enrollment.status === 'bounced').length,
});
